var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSidebarLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 106,
    height: 32,
    viewBox: "0 0 106 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6894 31.4545C25.4144 31.4545 32.4874 24.5353 32.4874 16C32.4874 7.46465 25.4144 0.54541 16.6894 0.54541C7.96442 0.54541 0.891418 7.46465 0.891418 16C0.891418 24.5353 7.96442 31.4545 16.6894 31.4545Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.244 20.7726C20.2207 20.7044 20.1975 20.6363 20.1975 20.5567C17.0611 19.9772 13.9712 19.0794 10.9626 17.8635C10.8232 18.0794 10.5909 18.2272 10.3238 18.2613C10.1147 20.6249 10.347 22.8522 10.7652 24.7726C10.9626 24.7953 11.1253 24.8976 11.2182 25.0567C11.8919 24.8181 12.5889 24.5453 13.2975 24.2613C15.3884 23.409 17.7697 22.2613 20.244 20.7726Z",
    fill: "url(#paint0_linear_1_5438)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0101 18.25C9.62678 18.1591 9.34799 17.8182 9.34799 17.4204C9.34799 17.3409 9.3596 17.2727 9.38284 17.1932C9.31314 17.1591 9.24344 17.1363 9.17375 17.1023C7.64041 16.4091 6.26971 15.7045 5.06163 15.0227C4.87577 15.2159 4.62021 15.3409 4.32981 15.3409C4.27173 15.3409 4.20203 15.3295 4.14395 15.3295C3.77223 16.2045 3.43536 17.1363 3.14496 18.125C3.29597 18.2273 3.3889 18.3977 3.3889 18.5909C3.3889 18.6818 3.36567 18.7613 3.33082 18.8295C4.22526 19.8863 5.28233 20.9886 6.51365 22.0795C7.59395 23.0454 8.87173 24.0227 10.3237 24.9432C10.3586 24.9091 10.4051 24.875 10.4515 24.8523C10.0333 22.8977 9.80102 20.6477 10.0101 18.25Z",
    fill: "url(#paint1_linear_1_5438)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7626 21.3522C24.9136 21.6477 25.053 21.9545 25.1924 22.25H25.2157C25.2505 22.25 25.2737 22.25 25.3086 22.2613C25.4131 22.034 25.5061 21.7954 25.599 21.5681C25.4712 21.4886 25.3899 21.3522 25.3551 21.2045C25.1924 21.1931 25.0414 21.1818 24.8788 21.1704C24.8672 21.25 24.8207 21.3068 24.7626 21.3522Z",
    fill: "url(#paint2_linear_1_5438)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.52222 16.9091C9.68485 16.7045 9.9404 16.5682 10.2192 16.5682H10.2308C10.3005 16.1818 10.3818 15.7955 10.4747 15.4091C11.0904 12.9318 12.1939 10.6136 13.7854 8.47727C13.553 8.26136 13.4136 7.95455 13.4136 7.61364C13.4136 7.34091 13.5066 7.10227 13.6576 6.89773C13.1232 6.40909 12.6005 5.95455 12.1126 5.54545C12.0197 5.61364 11.8919 5.65909 11.7641 5.65909C11.6131 5.65909 11.4621 5.60227 11.3576 5.5C9.12727 7.38636 6.74596 10.0227 4.93384 13.6023C5.16616 13.7841 5.31717 14.0568 5.31717 14.3636C5.31717 14.5 5.29394 14.625 5.23586 14.75C6.43232 15.4318 7.79141 16.1364 9.31313 16.8182C9.38283 16.8409 9.46414 16.875 9.52222 16.9091Z",
    fill: "url(#paint3_linear_1_5438)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0732 15.3295C28.1545 15.4658 28.2126 15.6135 28.2126 15.784C28.2126 16.2158 27.8758 16.5795 27.446 16.6249C27.1672 18.0226 26.7955 19.3749 26.3308 20.6704C26.4237 20.7499 26.4818 20.8408 26.5167 20.9658C28.1662 21.0454 29.8854 21.0454 31.651 20.9317C31.6162 21.0454 31.5697 21.1476 31.5348 21.2613C32.1389 19.6249 32.4758 17.8522 32.4758 16.0113C32.4758 14.2954 32.1854 12.6363 31.6626 11.0908C31.7091 11.2158 31.7439 11.3295 31.7788 11.4545C30.6288 12.8067 29.3975 14.1022 28.0732 15.3295Z",
    fill: "url(#paint4_linear_1_5438)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6349 22.8294C24.6349 22.6362 24.7278 22.4658 24.8788 22.3635C24.7394 22.0794 24.6116 21.7953 24.4722 21.5112C24.4374 21.5226 24.3909 21.5226 24.3445 21.5226C24.0541 21.5226 23.8217 21.3294 23.7636 21.068C23.0318 20.9885 22.3116 20.8976 21.5798 20.7839C21.4753 21.0453 21.2197 21.2271 20.9177 21.2271C20.7318 21.2271 20.5576 21.1589 20.4298 21.0453C18.2227 22.3748 15.8763 23.5567 13.4136 24.5567C12.6934 24.8521 11.9849 25.1248 11.2995 25.3748C11.2995 25.4203 11.2879 25.4658 11.2763 25.5112C14.0061 27.0794 17.3051 28.3408 21.1849 28.7385C22.7298 26.9658 23.9147 25.1248 24.8323 23.2726C24.7162 23.1703 24.6349 23.0112 24.6349 22.8294Z",
    fill: "url(#paint5_linear_1_5438)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.299 19.8409C23.0667 19.8409 22.846 19.75 22.6833 19.6023C22.3232 19.8409 21.9631 20.0796 21.603 20.3182C21.6146 20.3637 21.6263 20.4091 21.6263 20.4546C22.3348 20.5682 23.055 20.6591 23.7869 20.7387C23.8217 20.6477 23.8798 20.5682 23.9495 20.5114C23.8217 20.2727 23.6939 20.0227 23.5662 19.7955C23.4965 19.8296 23.4035 19.8409 23.299 19.8409Z",
    fill: "url(#paint6_linear_1_5438)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8187 16.4431C25.9475 17.1931 25.053 17.909 24.1121 18.6022C24.1586 18.7158 24.1934 18.8408 24.1934 18.9658C24.1934 19.2386 24.0656 19.4772 23.8798 19.6363C24.0076 19.8863 24.147 20.1363 24.2747 20.3863C24.298 20.3863 24.3212 20.3749 24.3444 20.3749C24.6348 20.3749 24.8788 20.5795 24.9252 20.8522C25.0879 20.8636 25.2389 20.8749 25.4015 20.8863C25.4944 20.6704 25.7035 20.5227 25.9475 20.5227C25.9707 20.5227 25.9939 20.5227 26.0055 20.534C26.4934 19.1931 26.8535 17.8636 27.1091 16.5908C27.0045 16.5568 26.9116 16.5113 26.8187 16.4431Z",
    fill: "url(#paint7_linear_1_5438)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1 4.57952C12.949 4.57952 12.8212 4.5227 12.7167 4.4318C12.5657 4.54543 12.4147 4.65907 12.2753 4.7727C12.3333 4.86361 12.3682 4.96589 12.3682 5.07952C12.3682 5.15907 12.3566 5.22725 12.3217 5.29543C12.8212 5.71589 13.3556 6.17043 13.9015 6.67043C14.1106 6.49998 14.3778 6.40907 14.6682 6.40907C14.9238 6.40907 15.1677 6.48861 15.3652 6.61361C16.3177 5.59089 17.3864 4.60225 18.5712 3.67043C18.5712 3.65907 18.5596 3.65907 18.5596 3.64771C16.8404 3.67043 15.2025 3.81816 13.6924 4.0568C13.6692 4.34089 13.4137 4.57952 13.1 4.57952Z",
    fill: "url(#paint8_linear_1_5438)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4045 18.966C22.4045 18.6932 22.5323 18.4432 22.7414 18.2841C20.302 14.0682 17.6535 10.875 15.4116 8.57959C15.2025 8.72732 14.947 8.81823 14.6682 8.81823C14.4475 8.81823 14.2384 8.76141 14.0641 8.65914C12.496 10.7614 11.404 13.0455 10.8 15.4773C10.7071 15.8637 10.6258 16.2387 10.5561 16.6137C10.8813 16.7387 11.102 17.0455 11.102 17.4091C11.102 17.4546 11.102 17.5114 11.0904 17.5569C13.6576 18.5796 16.7475 19.5682 20.2672 20.216C20.3833 19.9773 20.6273 19.8069 20.9177 19.8069C21.1152 19.8069 21.301 19.8864 21.4288 20.0228C21.7773 19.7955 22.1258 19.5682 22.4859 19.3296C22.4278 19.2273 22.4045 19.1023 22.4045 18.966Z",
    fill: "url(#paint9_linear_1_5438)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M19.6748 3.30666C22.2303 3.36348 24.7278 3.73848 27.1207 4.40894C27.3066 4.56803 27.4924 4.73848 27.6667 4.90894C27.6202 4.89757 27.5737 4.88621 27.5389 4.86348C27.8641 6.85212 28.1197 9.38621 27.9803 12.193C27.9338 13.1476 27.8409 14.0908 27.7131 15.0226C27.7596 15.0453 27.8061 15.068 27.8409 15.0908C29.1535 13.8748 30.4313 12.5453 31.651 11.0794C30.1409 6.6703 26.6561 3.15894 22.2303 1.53394C21.3242 2.07939 20.4647 2.65894 19.6515 3.24984C19.6631 3.26121 19.6748 3.28394 19.6748 3.30666Z",
    fill: "url(#paint10_linear_1_5438)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3914 4.26123C12.0662 4.31805 11.7641 4.38623 11.4505 4.45441C11.4505 4.49987 11.4389 4.53396 11.4273 4.57941C11.4389 4.57941 11.4389 4.59078 11.4505 4.59078C11.5434 4.53396 11.648 4.49987 11.7641 4.49987C11.8571 4.49987 11.9384 4.52259 12.0081 4.55669C12.0197 4.55669 12.0197 4.54532 12.0313 4.54532C12.1591 4.44305 12.2753 4.35214 12.3914 4.26123Z",
    fill: "url(#paint11_linear_1_5438)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9894 0.71582C19.094 0.727184 19.1869 0.749911 19.2914 0.761275C19.1985 0.738548 19.094 0.727184 18.9894 0.71582Z",
    fill: "url(#paint12_linear_1_5438)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8884 6.92043C4.01618 6.73861 4.15557 6.56816 4.29496 6.39771C4.16719 6.56816 4.02779 6.73861 3.8884 6.92043Z",
    fill: "url(#paint13_linear_1_5438)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M1.26315 12.6136C1.28639 12.5 1.32123 12.3863 1.34447 12.2727C1.30962 12.3863 1.28639 12.5 1.26315 12.6136Z",
    fill: "url(#paint14_linear_1_5438)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5975 6.81805C15.7833 7.03396 15.8995 7.30669 15.8995 7.60214C15.8995 7.88623 15.8066 8.13623 15.6439 8.34078C18.3854 11.1362 20.8247 14.3294 22.8808 17.818C22.9389 17.909 22.997 18.0112 23.0434 18.1135C23.1247 18.0908 23.2177 18.0794 23.299 18.0794C23.5429 18.0794 23.752 18.1703 23.9146 18.3181C24.8091 17.659 25.7151 16.943 26.598 16.1817C26.5283 16.0567 26.4818 15.9203 26.4818 15.7726C26.4818 15.3067 26.8652 14.9317 27.3414 14.9317H27.3763C27.5157 13.9658 27.597 13.034 27.6318 12.1703C27.7712 9.31805 27.504 6.74987 27.1672 4.76123C24.5652 4.02259 22.0212 3.69305 19.6167 3.63623C19.5237 3.84078 19.3146 3.9885 19.0707 3.9885C18.9545 3.9885 18.85 3.95441 18.7571 3.89759C17.5955 4.82941 16.5384 5.80669 15.5975 6.81805Z",
    fill: "url(#paint15_linear_1_5438)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5561 3.90891C10.649 3.8521 10.7652 3.818 10.8813 3.818C11.1137 3.818 11.3111 3.95437 11.4157 4.14755C11.7874 4.068 12.1591 3.98846 12.5308 3.92028C12.5773 3.64755 12.8212 3.43164 13.1116 3.43164C13.2394 3.43164 13.344 3.46573 13.4369 3.53391C15.3884 2.20437 17.247 1.28391 18.6758 0.681641C18.7455 0.693004 18.8152 0.704368 18.8849 0.704368C18.1647 0.602095 17.4328 0.556641 16.6778 0.556641C13.646 0.556641 10.8232 1.38619 8.4187 2.82937C8.52325 2.77255 8.62779 2.70437 8.73234 2.64755C9.25506 2.9771 9.87072 3.39755 10.5561 3.90891Z",
    fill: "url(#paint16_linear_1_5438)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2889 4.39766C10.2889 4.30675 10.3121 4.22721 10.347 4.14766C9.61517 3.60221 8.96466 3.17039 8.4187 2.81812C6.8389 3.7613 5.45658 4.97721 4.30658 6.3863C5.80506 5.74993 7.67527 5.06812 9.80102 4.5113C9.96365 4.47721 10.1263 4.43175 10.2889 4.39766Z",
    fill: "url(#paint17_linear_1_5438)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7404 29.193C22.9273 29.193 22.1258 29.1589 21.3359 29.0794C20.6621 29.8407 19.9419 30.568 19.1753 31.2612C21.4985 30.8976 23.6591 30.0453 25.5293 28.8066C25.3434 28.9316 25.1576 29.0453 24.9601 29.1589C24.5535 29.1816 24.147 29.193 23.7404 29.193Z",
    fill: "url(#paint18_linear_1_5438)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M4.32981 13.3978C4.43436 13.3978 4.5389 13.4205 4.63183 13.4432C4.84092 13.0228 5.07325 12.6023 5.30557 12.1932C6.82729 9.56823 8.80204 7.21595 11.195 5.21595C11.1833 5.1705 11.1717 5.12504 11.1717 5.07959C11.1717 5.00004 11.195 4.9205 11.2182 4.85232C11.1253 4.9205 10.9975 4.96595 10.8697 4.96595C10.6606 4.96595 10.4864 4.86368 10.3702 4.70459C10.2076 4.75004 10.045 4.78414 9.88234 4.82959C7.50103 5.45459 5.45658 6.22732 3.87678 6.9205C2.70355 8.50004 1.82072 10.3182 1.32123 12.2728C1.92527 12.7046 2.6687 13.2046 3.55153 13.75C3.74901 13.5341 4.02779 13.3978 4.32981 13.3978Z",
    fill: "url(#paint19_linear_1_5438)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M2.21567 18.5682C2.21567 18.4091 2.28537 18.2727 2.3783 18.1704C1.79749 17.4432 1.28638 16.7613 0.868195 16.1477C0.891427 18.1136 1.28638 19.9886 1.98335 21.7159C2.13436 20.8182 2.3086 19.9432 2.52931 19.0795C2.35506 18.9886 2.21567 18.7954 2.21567 18.5682Z",
    fill: "url(#paint20_linear_1_5438)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5051 21.284C26.4238 21.5112 26.203 21.6817 25.9475 21.6817H25.9359C25.8313 21.9317 25.7268 22.1703 25.6222 22.4203C25.7384 22.5226 25.8081 22.6703 25.8081 22.8408C25.8081 22.9999 25.7384 23.1362 25.6339 23.2499C26.2379 24.6135 26.7955 26.0112 27.295 27.443C27.202 27.5226 27.1207 27.6021 27.0278 27.6817C26.5051 26.1817 25.9359 24.7612 25.3435 23.4203C25.297 23.4317 25.2621 23.4317 25.2157 23.4317C25.1924 23.4317 25.1692 23.4317 25.146 23.4203C24.1935 25.3408 23.0086 27.1362 21.5914 28.784C22.846 28.8976 24.147 28.909 25.5177 28.8181C28.2591 26.9999 30.3849 24.3635 31.5349 21.2612C30.594 21.318 29.653 21.3521 28.7121 21.3521C27.9803 21.3408 27.2369 21.318 26.5051 21.284Z",
    fill: "url(#paint21_linear_1_5438)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M20.9293 29.0339C18.9778 28.818 17.0727 28.3748 15.2258 27.7044C13.8202 27.193 12.4379 26.5453 11.1136 25.7839C11.0904 25.8067 11.0672 25.818 11.0439 25.8408C11.2182 26.5112 11.4157 27.1476 11.6131 27.7158C12.0662 29.0339 12.5773 30.1703 13.0071 31.0339C14.1919 31.3067 15.4116 31.4544 16.6778 31.4544C17.5258 31.4544 18.3621 31.3862 19.1753 31.2612C18.9778 31.2953 18.7919 31.318 18.5944 31.3408C19.4424 30.5908 20.2207 29.818 20.9293 29.0339Z",
    fill: "url(#paint22_linear_1_5438)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7187 25.9204C10.5444 25.9204 10.3934 25.8408 10.2889 25.7272C8.53485 26.3181 6.95505 26.7613 5.65404 27.0681C5.56111 26.9772 5.46818 26.8977 5.38687 26.8068C6.71111 26.4999 8.32576 26.0568 10.1495 25.4431C10.1495 25.409 10.1379 25.3863 10.1379 25.3522C10.1379 25.3068 10.1495 25.2613 10.1611 25.2158C8.82526 24.3749 7.53586 23.3977 6.29293 22.3068C5.07324 21.2272 4.02778 20.1249 3.12172 19.0681C3.05202 19.1136 2.95909 19.1477 2.86616 19.1477C2.61061 20.1477 2.40152 21.1931 2.23889 22.2954C4.15556 26.5113 7.95404 29.7272 12.5773 30.9318C12.1591 30.0795 11.7061 29.034 11.2879 27.8181C11.0904 27.2386 10.8929 26.6022 10.7187 25.9204Z",
    fill: "url(#paint23_linear_1_5438)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5132 3.30682C18.5712 3.04545 18.8036 2.84091 19.094 2.84091C19.2334 2.84091 19.3611 2.89773 19.4657 2.97727C20.2091 2.43182 20.999 1.89773 21.8354 1.38636C21.9632 1.43182 22.1025 1.47727 22.2303 1.52273C21.2894 1.18182 20.3137 0.920455 19.2914 0.75C17.8626 1.31818 15.8531 2.25 13.7273 3.69318C15.3536 3.45455 16.945 3.32955 18.5132 3.30682Z",
    fill: "url(#paint24_linear_1_5438)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M2.80807 18H2.83131C3.11009 17.0341 3.44696 16.1023 3.8303 15.2045C3.53989 15.0341 3.34242 14.7273 3.34242 14.375C3.34242 14.2614 3.36565 14.1477 3.4005 14.0455C2.56413 13.5227 1.84393 13.0455 1.25151 12.625C1.0308 13.5795 0.903024 14.5795 0.879791 15.5909C1.35605 16.2955 1.94848 17.125 2.66868 18.0227C2.71514 18 2.76161 18 2.80807 18Z",
    fill: "url(#paint25_linear_1_5438)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6894 31.6818C12.4147 31.6818 8.38385 30.0454 5.36364 27.0908C2.33183 24.1249 0.670715 20.1931 0.670715 15.9999C0.670715 11.8181 2.34344 7.87493 5.36364 4.90902C8.38385 1.94312 12.4147 0.318115 16.701 0.318115C20.9874 0.318115 25.0066 1.95448 28.0384 4.90902C31.0702 7.87493 32.7313 11.8068 32.7313 15.9999C32.7313 20.1818 31.0586 24.1249 28.0384 27.0908C24.995 30.0454 20.9758 31.6818 16.6894 31.6818ZM16.6894 0.61357C8.02374 0.61357 0.961119 7.5113 0.961119 15.9999C0.961119 24.4886 8.01213 31.3863 16.6894 31.3863C25.3667 31.3863 32.4177 24.4886 32.4177 15.9999C32.4177 7.5113 25.3667 0.61357 16.6894 0.61357Z",
    fill: "url(#paint26_linear_1_5438)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2588 20.5393H38.8772V25.8854H38.2588V20.5393Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5344 20.5393H43.5733C44.81 20.5393 45.6122 21.1769 45.6122 22.2396V22.256C45.6122 23.4167 44.6262 24.0053 43.4563 24.0053H42.1361V25.8854H41.5177V20.5393H41.5344ZM43.5065 23.4494C44.4089 23.4494 45.0106 22.9753 45.0106 22.2723V22.256C45.0106 21.4876 44.4257 21.0952 43.5399 21.0952H42.1528V23.4494H43.5065Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M54.286 25.1336C53.7846 25.6568 53.1997 25.9674 52.4977 25.9674C51.5117 25.9674 50.7764 25.3625 50.7764 24.4633V24.4469C50.7764 23.7439 51.261 23.2207 52.0966 22.9101C51.729 22.485 51.5451 22.1581 51.5451 21.733V21.7166C51.5451 21.0136 52.1301 20.4414 52.9824 20.4414C53.7512 20.4414 54.3027 20.9809 54.3027 21.6512V21.6676C54.3027 22.3542 53.818 22.7793 53.0158 23.0573L54.2693 24.2998C54.5032 23.9565 54.7372 23.5477 54.921 23.1063L55.4224 23.3352C55.1884 23.842 54.9377 24.2998 54.6369 24.6758L55.5895 25.6241L55.1216 25.9837L54.286 25.1336ZM53.9183 24.7576L52.4643 23.2861C51.7457 23.5477 51.4114 23.9892 51.4114 24.4306V24.4469C51.4114 25.0191 51.8794 25.4606 52.5479 25.4606C53.066 25.4606 53.5172 25.199 53.9183 24.7576ZM53.7512 21.7003C53.7512 21.2589 53.4169 20.9482 52.9824 20.9482C52.4977 20.9482 52.1468 21.2916 52.1468 21.7166V21.733C52.1468 22.0436 52.2805 22.2889 52.6983 22.7139C53.3835 22.5014 53.7512 22.1581 53.7512 21.7003Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5419 21.0952H60.7035V20.5393H64.9986V21.0952H63.1602V25.8854H62.5419V21.0952Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2047 20.5393H71.1655V21.0952H67.823V22.9263H70.8145V23.4821H67.823V25.3623H71.1989V25.9181H67.2047V20.5393Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M73.5052 20.5393H74.1235V25.3296H77.1986V25.8854H73.5052V20.5393Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M79.388 20.5393H83.3488V21.0952H80.0063V22.9263H82.9978V23.4821H80.0063V25.3623H83.3822V25.9181H79.388V20.5393Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4378 23.2373C85.4378 21.7005 86.591 20.458 88.1954 20.458C89.1814 20.458 89.7831 20.8013 90.3346 21.3082L89.9167 21.7496C89.4488 21.3245 88.9474 21.0139 88.1954 21.0139C86.9921 21.0139 86.0729 21.9785 86.0729 23.2047V23.221C86.0729 24.4635 86.9921 25.4281 88.1954 25.4281C88.9474 25.4281 89.4321 25.1502 89.9669 24.6597L90.368 25.0521C89.7998 25.6243 89.1647 26.0003 88.1787 26.0003C86.6077 25.984 85.4378 24.7742 85.4378 23.2373Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M92.1061 23.2373C92.1061 21.7496 93.2425 20.458 94.897 20.458C96.5683 20.458 97.6713 21.7332 97.6713 23.2047V23.221C97.6713 24.6924 96.5349 25.984 94.8803 25.984C93.2258 25.984 92.1061 24.7088 92.1061 23.2373ZM97.0362 23.2373C97.0362 22.0112 96.1338 21.0139 94.8803 21.0139C93.6269 21.0139 92.7411 21.9948 92.7411 23.2047V23.221C92.7411 24.4308 93.6436 25.4281 94.897 25.4281C96.1505 25.4281 97.0362 24.4472 97.0362 23.2373Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M100.044 20.5393H100.663L102.652 23.4658L104.64 20.5393H105.259V25.8854H104.64V21.5529L102.652 24.414H102.618L100.629 21.5529V25.8854H100.028V20.5393H100.044Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0162 6H39.1372L45.8303 14.8168V6H47V17H46.0415L39.1697 7.98168V17H38V6H38.0162Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2538 16C54.4092 16 55.2319 15.5714 55.9147 14.9206L56.7024 15.5556C55.8446 16.4127 54.8118 17 53.2188 17C50.8906 17 49 15.381 49 13C49 10.7778 50.7155 9 53.0613 9C55.5646 9 57 10.8095 57 13.0635C57 13.1746 57 13.2857 56.9825 13.4603H50.2779C50.453 15.0635 51.7659 16 53.2538 16ZM55.7221 12.5238C55.5821 11.127 54.6893 9.93651 53.0263 9.93651C51.5733 9.93651 50.453 11.0317 50.2779 12.5238H55.7221Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1473 14.8683V10.2915H58V9.2884H59.1473V7H60.3801V9.2884H63V10.2915H60.3801V14.7116C60.3801 15.6364 60.9452 15.9655 61.7671 15.9655C62.1781 15.9655 62.5377 15.8871 62.9658 15.6991V16.6708C62.5377 16.8746 62.0753 17 61.476 17C60.1575 17 59.1473 16.4044 59.1473 14.8683Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M64 15.2838L64.7495 14.4012C65.8574 15.4146 66.9328 15.9212 68.3992 15.9212C69.833 15.9212 70.778 15.153 70.778 14.107V14.0743C70.778 13.0773 70.2403 12.5215 68.0081 12.0475C65.5479 11.5082 64.4236 10.7236 64.4236 8.9584V8.92571C64.4236 7.2422 65.9063 6 67.9267 6C69.4745 6 70.5988 6.44131 71.6741 7.30758L70.9735 8.23923C69.9796 7.42199 68.9857 7.07875 67.8941 7.07875C66.5092 7.07875 65.6293 7.84695 65.6293 8.81129V8.84398C65.6293 9.85736 66.1833 10.4131 68.5295 10.9198C70.9084 11.4428 72 12.3091 72 13.9435V13.9762C72 15.8068 70.4684 17 68.3666 17C66.6721 17 65.2872 16.4279 64 15.2838Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M74 9.17081H75.1803V10.677C75.8197 9.7764 76.7541 9 78.2131 9C80.1147 9 82 10.4286 82 12.8975V12.9286C82 15.382 80.1311 16.8416 78.2131 16.8416C76.7377 16.8416 75.7869 16.0807 75.1803 15.2422V19H74V9.17081ZM80.8033 12.9441V12.913C80.8033 11.1429 79.5082 10.0093 78.0164 10.0093C76.541 10.0093 75.1475 11.1894 75.1475 12.8975V12.9286C75.1475 14.6677 76.541 15.8323 78.0164 15.8323C79.541 15.8323 80.8033 14.7609 80.8033 12.9441Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M83 14.5998V14.5678C83 12.9039 84.3835 12.0399 86.4094 12.0399C87.4306 12.0399 88.1388 12.1679 88.8471 12.3759V12.1359C88.8471 10.7599 87.9906 10.04 86.4918 10.04C85.5529 10.04 84.8118 10.264 84.0706 10.6L83.7082 9.65598C84.5812 9.27199 85.4376 9 86.6071 9C87.7271 9 88.6165 9.30399 89.1765 9.84797C89.7365 10.392 90 11.1279 90 12.1199V16.8398H88.8306V15.6878C88.2706 16.3758 87.3647 16.9998 85.9647 16.9998C84.4824 17.0158 83 16.1998 83 14.5998ZM88.8635 14.0079V13.2879C88.2706 13.1279 87.5129 12.9519 86.5412 12.9519C85.0588 12.9519 84.2188 13.5759 84.2188 14.5038V14.5358C84.2188 15.5118 85.1412 16.0718 86.2282 16.0718C87.6776 16.0878 88.8635 15.2398 88.8635 14.0079Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M93.0148 9.14782H94.0815V11.192C94.6148 9.8941 95.6519 8.95313 97 9.0018V10.2672H96.9111C95.3407 10.2672 94.0667 11.5002 94.0667 13.8689V17H93V9.14782H93.0148Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M99 6H100.175V13.5857L104.434 9.20498H105.902L102.59 12.5549L106 17H104.597L101.774 13.3763L100.175 14.9707V17H99V6Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_5438",
    x1: 0.876662,
    y1: 21.4627,
    x2: 32.4702,
    y2: 21.4627,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_5438",
    x1: 0.876659,
    y1: 19.9707,
    x2: 32.4702,
    y2: 19.9707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_5438",
    x1: 0.876449,
    y1: 21.7223,
    x2: 32.4702,
    y2: 21.7223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1_5438",
    x1: 0.87665,
    y1: 11.2014,
    x2: 32.4702,
    y2: 11.2014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1_5438",
    x1: 0.876632,
    y1: 16.1664,
    x2: 32.4702,
    y2: 16.1664,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1_5438",
    x1: 0.876664,
    y1: 24.7592,
    x2: 32.4702,
    y2: 24.7592,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1_5438",
    x1: 0.876603,
    y1: 20.1747,
    x2: 32.4702,
    y2: 20.1747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1_5438",
    x1: 0.876665,
    y1: 18.6652,
    x2: 32.4702,
    y2: 18.6652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1_5438",
    x1: 0.876689,
    y1: 5.14941,
    x2: 32.4702,
    y2: 5.14941,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1_5438",
    x1: 0.876661,
    y1: 14.4019,
    x2: 32.4702,
    y2: 14.4019,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1_5438",
    x1: 0.87661,
    y1: 8.30933,
    x2: 32.4702,
    y2: 8.30933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1_5438",
    x1: 0.876627,
    y1: 4.42706,
    x2: 32.4701,
    y2: 4.42706,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1_5438",
    x1: 0.87688,
    y1: 0.736411,
    x2: 32.47,
    y2: 0.736411,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1_5438",
    x1: 0.876687,
    y1: 6.65377,
    x2: 32.47,
    y2: 6.65377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1_5438",
    x1: 0.876671,
    y1: 12.4395,
    x2: 32.4699,
    y2: 12.4395,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1_5438",
    x1: 0.876602,
    y1: 10.9847,
    x2: 32.4701,
    y2: 10.9847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1_5438",
    x1: 0.876666,
    y1: 2.34192,
    x2: 32.4702,
    y2: 2.34192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1_5438",
    x1: 0.876676,
    y1: 4.6071,
    x2: 32.4702,
    y2: 4.6071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1_5438",
    x1: 0.87669,
    y1: 30.032,
    x2: 32.4702,
    y2: 30.032,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1_5438",
    x1: 0.876678,
    y1: 9.2272,
    x2: 32.4702,
    y2: 9.2272,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1_5438",
    x1: 0.876663,
    y1: 18.9356,
    x2: 32.4703,
    y2: 18.9356,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1_5438",
    x1: 0.876635,
    y1: 25.057,
    x2: 32.4702,
    y2: 25.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1_5438",
    x1: 0.876656,
    y1: 28.6185,
    x2: 32.4702,
    y2: 28.6185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1_5438",
    x1: 0.876664,
    y1: 24.9938,
    x2: 32.4702,
    y2: 24.9938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1_5438",
    x1: 0.876697,
    y1: 2.23148,
    x2: 32.4702,
    y2: 2.23148,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1_5438",
    x1: 0.876643,
    y1: 15.3098,
    x2: 32.4702,
    y2: 15.3098,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1_5438",
    x1: 0.66622,
    y1: 15.9999,
    x2: 32.717,
    y2: 15.9999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F9B059"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F1592B"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarLogo);
export default __webpack_public_path__ + "static/media/sidebarLogo.f08daff990361bd420dc4c2ccab8fdbc.svg";
export { ForwardRef as ReactComponent };